<template>
  <div>
    <!-- BOC:[error] -->
    <AError :api="api"></AError>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>{{$t("view.PageBackendPasswordChange.password_change_title")}}</v-card-title>
        <v-card-text>
          <span v-for="(field, i) in inputs" :key="i">
            <template>
              <FormInput
                :value="form[field.key]"
                :callbackInput="getInput"
                :field="field"
                @input="form[field.key] = $event"
              />
            </template>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)">{{$t("action.cancel")}} </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            {{$t("action.confirm")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <!-- EOC -->
  </div>
</template>


<script>
import FormInput from "@/components/Bread/Password/FormInput";
import i18n from '@/plugins/i18n'
export default {
  props: ["self", "role", "model", "url", "action", "callbackSuccess"],
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    form: {
      password:null,
      confirmPassword:null
    },
    inputs: [
       {
        key: "oldPassword",
       name: i18n.t("view.PageBackendPasswordChange.old_password"),
      },
      {
        key: "password",
        name:i18n.t("view.PageBackendPasswordChange.new_password"),
      },
      {
        key: "confirmPassword",
        name:i18n.t("view.PageBackendPasswordChange.confirm_password"),
      },
    ],
  }),

  components: {
    FormInput,
  },
  created() {
    //BOC:[api]
    this.api.url = `${this.$api.servers.backend}/v1/password/change`
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  methods: {
    getInput(value) {
      this.form.eventId = value;
    },
    //BOC:[form]
    validate() {
      this.api.callbackReset();
      if (this.$refs.form.validate()) {
        if(this.form.password == this.form.confirmPassword){

        this.submit();
        }else{
           this.api.callbackError("Passwords does not match.");
        }
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
    //EOC
  },
};
</script>
